/**
 * Mobile menu
 */



// function toggleMenuOpen() {
//     const menu = document.querySelector('.main-menu'); // Znajduje element menu
//     if (menu) {
//         menu.classList.toggle('open'); // Dodaje lub usuwa klasę 'open'
//     }
// }
//
//
// document.querySelectorAll('.open-menu').forEach(button => {
//     button.addEventListener('click', toggleMenuOpen);
// });
//
// function closeMobileMenu() {
//     const menu = document.querySelector('.main-menu'); // Znajduje element menu
//     if (menu.classList.contains('open')) {
//         menu.classList.remove('open'); // Usuwa klasę 'open'
//     }
//     else{
//         console.log("nie open");
//     }
// }
//
// document.querySelector('.close-mobile-menu').addEventListener('click', closeMobileMenu);
